<template>
  <div class="page">
    <div class="locations-white locations-generic">
      <section>
        <div class="locations-title">Clark Park Boathouse, Chicago</div>
        <!-- <strong>Season: April - October</strong> -->
        <!-- <Strong>Open Seven Days Per Week</Strong> -->
      </section>
      <section>
        <!-- <strong>Open: Saturday, May 13</strong> -->
      </section>
      <section>
          <strong>Hours:</strong> Monday, Friday, Saturday, Sunday<br>
           9:00 a.m. until last rental, 6:00 p.m.<br>
     </section>
      <section>
        <strong>Boats Rentals:</strong>
        Kayaks and Canoes.
      </section>
      <section>
        <strong>Events:</strong>
        <a class="Twilight" href="https://www.chicagoriverpaddle.com/#/Events">
        Twilight Nature Paddle 
        </a>
      </section>
      <section>
        <strong>Minimum age:</strong>
        5 years, 45 lbs. (may be higher
        depending on river and weather conditions)
      </section>
      <strong>Please note:</strong> we do not allow renters to paddle south on the river from this location.
      <br /><br />
      <a class="btn-primary btn" href="https://www.google.com/maps/dir/?api=1&destination=41.9459078,-87.6955711">
        <strong>Directions</strong>
      </a>
    </div>
    <div class="locations-green locations-generic">
      <call-button tel-number="773-704-2663"/>
      <br />3400 N. Rockwell, Chicago, IL 60625    
    </div>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.649539139572!2d-87.69679298455684!3d41.9433815792171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880fd2793f7067f7%3A0xdbf38b161d4ed886!2s3400%20N%20Rockwell%20St%2C%20Chicago%2C%20IL%2060618!5e0!3m2!1sen!2sus!4v1588721050300!5m2!1sen!2sus" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
  </div>
</template>s

<script>
import CallButton from "../CallButton"

export default {
  name: "ClarkPark",
  components: {CallButton},
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.call-button {
  color: white;
}
iframe {
  max-width: 90%;
}
.page {
  background-image: url("../../assets/pic3.png");
  flex-direction: column;
  padding-left: 20px;
}
section {
  margin-bottom: 10px;
}
</style>
